export const catalogSectionSliderOptions = (instance, options, maxItems) => {
    let responsiveItemCounts = {
        1800: maxItems,
        1440: 3.1,
        1024: 2.1,
    }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        cssMode: false,
        spaceBetween: 18,
        pagination: {
            el: instance.paginationEl,
            type: 'bullets',
            clickable: true,
            dynamicBullets: false,
            dynamicMainBullets: 10,
            hideOnClick: false,
        },
        breakpoints: breakpoints
    }
}